import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { Line, Pie, Bar } from "@antv/g2plot";
import OperationChart from "./components/OperationChart.vue";
import CommunityActivity from "./components/CommunityActivity.vue";
import CommunityExpo from "./components/CommunityExpo.vue";
import NewUserChart from "./components/NewUserChart.vue";
import NewHouseChart from "./components/NewHouseChart.vue";
import SessionsNumChart from "./components/SessionsNumChart.vue";
import UserSafetyChart from "./components/UserSafetyChart.vue";
import FraudSessionsChart from "./components/FraudSessionsChart.vue";
import FraudResolutionChart from "./components/FraudResolutionChart.vue";
import FraudulentPlatformChart from "./components/FraudulentPlatformChart.vue";
import dayjs from "dayjs";
import { orderBy } from "lodash";
import Vue from "vue";
import { GridLayout, GridItem } from "vue-grid-layout";
import ActiveHouseChart from "@/views/system/index/components/ActiveHouseChart.vue";
Vue.component("d2-grid-layout", GridLayout);
Vue.component("d2-grid-item", GridItem);
export default {
  components: {
    ActiveHouseChart: ActiveHouseChart,
    SessionsNumChart: SessionsNumChart,
    OperationChart: OperationChart,
    CommunityActivity: CommunityActivity,
    CommunityExpo: CommunityExpo,
    NewUserChart: NewUserChart,
    NewHouseChart: NewHouseChart,
    UserSafetyChart: UserSafetyChart,
    FraudSessionsChart: FraudSessionsChart,
    FraudResolutionChart: FraudResolutionChart,
    FraudulentPlatformChart: FraudulentPlatformChart
  },
  data: function data() {
    return {
      // 复杂审核占比
      houseComplexAuditTimeType: 1,
      getAnalysisHouseComplexAuditLoading: false,
      houseComplexAuditStartDate: dayjs().subtract(1, "week").format("YYYY-MM-DD"),
      houseComplexAuditEndDate: dayjs().subtract(1, "day").format("YYYY-MM-DD"),
      registerUserGrain: "day",
      // day|week|month：月|quarter:季度|year:年
      registerUserStartDate: dayjs().subtract(1, "month").format("YYYY-MM-DD"),
      registerUserEndDate: dayjs().subtract(1, "day").format("YYYY-MM-DD"),
      // 活跃房源
      getActiveHouseCountLoading: false,
      activeHouseGrain: "day",
      // day|week|month：月|quarter:季度|year:年
      activeHouseStartDate: dayjs().subtract(1, "month").format("YYYY-MM-DD"),
      activeHouseEndDate: dayjs().subtract(1, "day").format("YYYY-MM-DD"),
      activeHouseCity: [],
      // 今日会话数
      getConversationDailyCountLoading: false,
      // 房源审核量
      getHouseAuditCountLoading: false,
      houseAuditTimeType: 1,
      // 近7天，近一个月、近3个月

      // 邀请排行
      getInviterTopCountLoading: false,
      inviterTopTimeType: 1,
      // 近7天，近一个月、近3个月
      inviterTopTotal: null,
      // Lifestyle&唯心市集
      getLifestyleLoading: false,
      lifestyleGrain: "day",
      // day|week|month：月|quarter:季度|year:年
      lifestyleStartDate: dayjs().subtract(1, "month").format("YYYY-MM-DD"),
      lifestyleEndDate: dayjs().subtract(1, "day").format("YYYY-MM-DD"),
      layout: {
        layout: [{
          x: 0,
          y: 0,
          w: 6,
          h: 11,
          i: "0"
        },
        // 新注册用户
        {
          x: 6,
          y: 0,
          w: 6,
          h: 11,
          i: "3"
        },
        // 今日会话数

        {
          x: 0,
          y: 10,
          w: 6,
          h: 11,
          i: "1"
        },
        // 活跃房源
        {
          x: 6,
          y: 10,
          w: 6,
          h: 11,
          i: "7"
        },
        // 新增房源

        {
          x: 0,
          y: 10,
          w: 6,
          h: 22,
          i: "2"
        },
        // 房源审核量
        {
          x: 6,
          y: 10,
          w: 6,
          h: 11,
          i: "6"
        },
        // 房源复杂审核

        {
          x: 6,
          y: 20,
          w: 6,
          h: 11,
          i: "4"
        },
        // 房东转化
        {
          x: 0,
          y: 32,
          w: 6,
          h: 11,
          i: "5"
        },
        // 社区活跃

        {
          x: 6,
          y: 31,
          w: 6,
          h: 11,
          i: "8"
        },
        // 社区曝光

        {
          x: 0,
          y: 43,
          w: 6,
          h: 11,
          i: "9"
        },
        // 用户安全数据
        {
          x: 6,
          y: 43,
          w: 6,
          h: 11,
          i: "10"
        },
        // 诈骗会话图表

        {
          x: 0,
          y: 44,
          w: 6,
          h: 11,
          i: "11"
        },
        // 用户安全-手动/自动处理数量占比
        {
          x: 6,
          y: 44,
          w: 6,
          h: 11,
          i: "12"
        } // 诈骗平台图表
        ],
        colNum: 12,
        rowHeight: 30,
        isDraggable: true,
        isResizable: true,
        isMirrored: false,
        verticalCompact: true,
        margin: [10, 10],
        useCssTransforms: true
      },
      cityList: []
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var _this$$refs$operation;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this.showInfo();
            _context.n = 1;
            return (_this$$refs$operation = _this.$refs.operationChart[0]) === null || _this$$refs$operation === void 0 ? void 0 : _this$$refs$operation.getHouseAuditCount();
          case 1:
            _this.getInviterTopCount();
            _this.getAnalysisStatistics();
            _this.getAnalysisHouseComplexAudit();
            _this.getCityListByPy();
          case 2:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  filters: {
    grain: function grain(type) {
      var res = "";
      switch (type) {
        case "day":
          res = "天";
          break;
        case "week":
          res = "周";
          break;
        case "month":
          res = "月";
          break;
        case "week":
          res = "周";
          break;
        case "quarter":
          res = "季";
          break;
        case "year":
          res = "年";
          break;
        default:
          break;
      }
      return res;
    }
  },
  watch: {},
  methods: {
    getCityListByPy: function getCityListByPy() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return _this2.$api.getCityListByPy();
            case 1:
              res = _context2.v;
              _this2.cityList = res.data;
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    getAnalysisHouseComplexAudit: function getAnalysisHouseComplexAudit() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var start, end, res, auditorComplexTotal;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _this3.getAnalysisHouseComplexAuditLoading = true;
              start = dayjs().format("YYYY-MM-DD");
              end = dayjs().format("YYYY-MM-DD");
              if (_this3.houseComplexAuditTimeType === 0) {
                start = dayjs().subtract(0, "day").format("YYYY-MM-DD");
              } else if (_this3.houseComplexAuditTimeType == 1) {
                start = dayjs().subtract(1, "week").format("YYYY-MM-DD");
              } else if (_this3.houseComplexAuditTimeType == 2) {
                start = dayjs().subtract(1, "month").format("YYYY-MM-DD");
              } else if (_this3.houseComplexAuditTimeType == 3) {
                start = dayjs().subtract(3, "month").format("YYYY-MM-DD");
              }
              _context3.n = 1;
              return _this3.$api.getAnalysisHouseComplexAudit({
                grain: "day",
                start: start,
                end: end
              });
            case 1:
              res = _context3.v;
              auditorComplexTotal = {};
              res.data.forEach(function (item) {
                var values = item.value.split("/");
                delete item.time;
                item.value = parseInt(values[0]);
                item.total = parseInt(values[1]);
                if (auditorComplexTotal["complex_total_" + item.name] && auditorComplexTotal["complex_total_" + item.name] > 0) {
                  auditorComplexTotal["complex_total_" + item.name] += item.value;
                } else {
                  auditorComplexTotal["complex_total_" + item.name] = item.value;
                }
                if (item.auditName == "middleman_landlord") {
                  item.auditName = "认证";
                  item.auditNameSort = 1;
                }
                if (item.auditName == "quarterly_user") {
                  item.auditName = "季度";
                  item.auditNameSort = 2;
                }
                if (item.auditName == "brand_user") {
                  item.auditName = "充值";
                  item.auditNameSort = 3;
                }
                if (item.auditName == "bnb_user") {
                  item.auditName = "民宿";
                  item.auditNameSort = 4;
                }
              });
              res.data.forEach(function (item) {
                item.name += "-" + (auditorComplexTotal["complex_total_" + item.name || ''] / item.total * 100).toFixed(1) + "%";
              });
              _this3.getAnalysisHouseComplexAuditLoading = false;
              res.data = orderBy(res.data, ["total", "auditNameSort"], ["desc"]);
              if (_this3.houseComplexAuditBar) {
                _this3.houseComplexAuditBar.changeData(res.data);
              } else {
                _this3.houseComplexAuditBar = new Bar("container-house-complex-audit", {
                  data: res.data,
                  appendPadding: [70, 0, 0, 0],
                  legend: {
                    position: "top",
                    offsetY: 70
                  },
                  isStack: true,
                  xField: "value",
                  yField: "name",
                  seriesField: "auditName",
                  label: {
                    // 可手动配置 label 数据标签位置
                    position: "middle",
                    // 'left', 'middle', 'right'
                    // 可配置附加的布局方法
                    layout: [
                    // 柱形图数据标签位置自动调整
                    {
                      type: "interval-adjust-position"
                    },
                    // 数据标签防遮挡
                    {
                      type: "interval-hide-overlap"
                    },
                    // 数据标签文颜色自动调整
                    {
                      type: "adjust-color"
                    }]
                  }
                });
                _this3.houseComplexAuditBar.render();
              }
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    getAnalysisStatistics: function getAnalysisStatistics() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var res;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _this4.getLifestyleLoading = true;
              _context4.n = 1;
              return _this4.$api.getAnalysisStatistics({
                // chart_name: "conversation_daily",
                grain: _this4.lifestyleGrain,
                start: _this4.lifestyleStartDate,
                end: _this4.lifestyleEndDate
              });
            case 1:
              res = _context4.v;
              _this4.getLifestyleLoading = false;
              res.data = orderBy(res.data, ["time"], ["name"]);
              if (_this4.lifestyleLine) {
                _this4.lifestyleLine.changeData(res.data);
              } else {
                _this4.$nextTick(function () {
                  _this4.lifestyleLine = new Line("container-lifestyle", {
                    data: res.data,
                    xField: "time",
                    yField: "value",
                    seriesField: "name",
                    legend: {
                      position: "top",
                      offsetY: 70
                    },
                    smooth: true,
                    appendPadding: [70, 0, 0, 0]
                  });
                  _this4.lifestyleLine.render();
                });
              }
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    getInviterTopCount: function getInviterTopCount() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var start, end, res;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _this5.getInviterTopCountLoading = true;
              start = dayjs().format("YYYY-MM-DD");
              end = dayjs().format("YYYY-MM-DD");
              if (_this5.inviterTopTimeType == 1) {
                start = dayjs().subtract(1, "week").format("YYYY-MM-DD");
              } else if (_this5.inviterTopTimeType == 2) {
                start = dayjs().subtract(1, "month").format("YYYY-MM-DD");
              } else if (_this5.inviterTopTimeType == 3) {
                start = dayjs().subtract(3, "month").format("YYYY-MM-DD");
              }
              _context5.n = 1;
              return _this5.$api.getChartData({
                chart_name: "inviter_top",
                grain: "day",
                start: start,
                end: end
              });
            case 1:
              res = _context5.v;
              _this5.getInviterTopCountLoading = false;
              res.data = orderBy(res.data, ["value"], ["desc"]);
              _this5.inviterTopTotal = res.data.shift();
              if (_this5.inviterTopBar) {
                _this5.inviterTopBar.changeData(res.data);
              } else {
                _this5.inviterTopBar = new Bar("container-inviter-top", {
                  data: res.data,
                  legend: {
                    position: "top-left",
                    offsetY: 70
                  },
                  // seriesField: "name",
                  smooth: true,
                  appendPadding: [70, 0, 0, 0],
                  xField: "value",
                  yField: "name",
                  barWidthRatio: 0.8,
                  meta: {
                    name: {
                      alias: "邀请人"
                    },
                    value: {
                      alias: "邀请量"
                    }
                  }
                });
                _this5.inviterTopBar.render();
              }
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    log: function log() {
      var arg1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "log";
      for (var _len = arguments.length, logs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        logs[_key - 1] = arguments[_key];
      }
      if (logs.length === 0) {
        console.log(arg1);
      } else {
        console.group(arg1);
        logs.forEach(function (e) {
          console.log(e);
        });
        console.groupEnd();
      }
    },
    // 显示提示
    showInfo: function showInfo() {
      this.$notify({
        title: "提示",
        message: "你可以按住卡片拖拽改变位置；或者在每个卡片的右下角拖动，调整卡片大小"
      });
    },
    // 测试代码
    layoutUpdatedHandler: function layoutUpdatedHandler(newLayout) {
      // console.group("layoutUpdatedHandler");
      // newLayout.forEach((e) => {
      //     console.log(
      //         `{'x': ${e.x}, 'y': ${e.y}, 'w': ${e.w}, 'h': ${e.h}, 'i': '${e.i}'},`
      //     );
      // });
      // console.groupEnd();
    },
    resizeHandler: function resizeHandler(i, newH, newW) {
      this.log("resizeHandler", "i: ".concat(i, ", newH: ").concat(newH, ", newW: ").concat(newW));
    },
    moveHandler: function moveHandler(i, newX, newY) {
      this.log("moveHandler", "i: ".concat(i, ", newX: ").concat(newX, ", newY: ").concat(newY));
    },
    resizedHandler: function resizedHandler(i, newH, newW, newHPx, newWPx) {
      this.log("resizedHandler", "i: ".concat(i, ", newH: ").concat(newH, ", newW: ").concat(newW, ", newHPx: ").concat(newHPx, ", newWPx: ").concat(newWPx));
    },
    movedHandler: function movedHandler(i, newX, newY) {
      this.log("movedHandler", "i: ".concat(i, ", newX: ").concat(newX, ", newY: ").concat(newY));
    }
  }
};